module.exports = __webpack_public_path__ + "img/YouPlusAnchorChallenger2020ZH-9.2441cba6.jpg";